import { sentry } from 'legacy/utils/sentry'

import { type PreferredLane } from '../domain/PreferredLane'
import {
  SuggestedPreferredLaneAction,
  type SuggestedPreferredLane,
} from '../domain/SuggestedPreferredLane'
import { type LaneHistoryRepository } from '../infra/LaneHistoryRepository'
import { type PreferredLaneRepository } from '../infra/PreferredLaneRepository'
import { type SuggestedPreferredLaneRepository } from '../infra/SuggestedPreferredLaneRepository'
import { addBookToLaneHistoryFactory } from './addBookToLaneHistory'
import { getSuggestedPreferredLanesFactory } from './getSuggestedPreferredLanes'
import { shouldSuggestPreferredLaneOnBookFactory } from './shouldSuggestPreferredLaneOnBook'
import { suggestPreferredLaneFactory } from './suggestPreferredLane'

export type TrackLaneBook = (preferredLane: PreferredLane) => Promise<Array<SuggestedPreferredLane>>

export type TrackLaneBookDependencies = {
  laneHistoryRepository: LaneHistoryRepository
  preferredLaneRepository: PreferredLaneRepository
  suggestedPreferredLaneRepository: SuggestedPreferredLaneRepository
}

export function trackLaneBookFactory({
  laneHistoryRepository,
  preferredLaneRepository,
  suggestedPreferredLaneRepository,
}: TrackLaneBookDependencies): TrackLaneBook {
  const addBookToLaneHistory = addBookToLaneHistoryFactory({ laneHistoryRepository })

  const getSuggestedPreferredLanes = getSuggestedPreferredLanesFactory({
    suggestedPreferredLaneRepository,
  })

  const shouldSuggestPreferredLaneOnBook = shouldSuggestPreferredLaneOnBookFactory({
    laneHistoryRepository,
    preferredLaneRepository,
    suggestedPreferredLaneRepository,
  })

  const suggestPreferredLane = suggestPreferredLaneFactory({
    laneHistoryRepository,
    suggestedPreferredLaneRepository,
  })

  return async function trackLaneBook(
    preferredLane: PreferredLane
  ): Promise<Array<SuggestedPreferredLane>> {
    try {
      await addBookToLaneHistory(preferredLane)

      if (await shouldSuggestPreferredLaneOnBook(preferredLane)) {
        await suggestPreferredLane(preferredLane, SuggestedPreferredLaneAction.Book)
      }
    } catch (error) {
      sentry.log(error)
    }

    try {
      return getSuggestedPreferredLanes()
    } catch (error) {
      sentry.log(error)
      return []
    }
  }
}
